import { render, staticRenderFns } from "./OrganismInitialSetup.vue?vue&type=template&id=3cff0b7c&"
import script from "./OrganismInitialSetup.vue?vue&type=script&lang=js&"
export * from "./OrganismInitialSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports